import Features from "./features";
import FooterHomepage from "./footer-homepage";
import FooterCon from "./FooterCon";
import SecuritySection from "./securitySection";

function FeaturesBottom(){    

    return (
        <>        
            
            <Features/>  
            
            <SecuritySection/>        

            <FooterCon/>

            <FooterHomepage/>    
        </>
    )
}

export default FeaturesBottom;
